<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['view_student'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-md-4">
              <div class="card">
                <div class="card-body p-3">
                  <div class=" mb-2 d-flex justify-content-between">
                    <span
                      ><a
                        @click="$router.go(-1)"
                        type="button"
                        class="btn-sm btn btn-primary"
                      >
                        <i class="mdi mdi-undo"></i> back</a
                      ></span
                    >
                    <!-- <span><router-link :to="{ path: '/printprofile',  query: { id: this.$route.query.id }}" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-printer"></i> Print</router-link></span> -->
                  </div>
                  <table v-for="item in students" :key="item.id" class="table">
                    <tr>
                      <td colspan="2">
                        <img
                          :src="getFiles(item.student.student_photo)"
                          height="100"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Full Name</td>
                      <td>
                        <b class="text-primary h7"
                          >{{ item.student.first_name }}
                          {{ item.student.last_name }}
                        </b>
                      </td>
                    </tr>
                    <tr>
                      <td>Gender</td>
                      <td>
                        <span class="text-primary h7"
                          >{{ item.student.gender }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>Class</td>
                      <td>
                        <span class="text-primary h7"
                          >{{ item.class.name }} {{ item.stream.name }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>Age</td>
                      <td>
                        <span class="text-primary h7"
                          >{{ getAge(item.student.dob) }} yrs
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>Address</td>
                      <td>
                        <span class="text-primary h7"
                          >{{ item.student.district }}
                          {{ item.student.address }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>SchoolPay Code</td>
                      <td>
                        <span class="text-primary h7"
                          >{{ item.student.school_pay_code }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <div class="d-flex justify-content-between">
                          <b-button
                            @click="
                              edit(
                                item.student.student_photo,
                                item.student.first_name,
                                item.student.last_name,
                                item.student.gender,
                                item.student.dob,
                                item.student.district,
                                item.student.address,
                                item.student.school_pay_code,
                              )
                            "
                            type="button"
                            class="btn-sm btn"
                            variant="success"
                            v-b-modal.edit
                          >
                            <i class="mdi mdi-square-edit-outline"></i> Edit
                          </b-button>
                        </div>
                      </td>
                    </tr>
                  </table>

                  <span style="color: black;font-size:14px">
                    <b
                      >FEES BALANCE :
                      <span v-if="this.bursarytype == 'Full Bursary'">0</span>
                      <span v-else-if="this.bursarytype == 'Half Bursary'">
                        {{
                          Number(this.total / 2) -
                            Number(this.amount) -
                            Number(this.exemptions) -
                            Number(this.balances)
                        }}
                      </span>
                      <span v-else-if="this.bursarytype == 'Custom'">
                        {{
                          Number(this.bursaryvalue) -
                            Number(this.amount) -
                            Number(this.exemptions) -
                            Number(this.balances)
                        }}
                      </span>
                      <span v-else-if="this.bursarytype == 'Percentage'">
                        {{
                          Number(this.total * (this.bursaryvalue / 100)) -
                            Number(this.amount) -
                            Number(this.exemptions) -
                            Number(this.balances)
                        }}
                      </span>
                      <span v-else>
                        {{
                          Number(this.total) -
                            Number(this.amount) -
                            Number(this.exemptions) -
                            Number(this.balances)
                        }}
                      </span>
                    </b>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-8">
              <b-tabs pills nav-class="p-0" content-class="text-primary">
                <b-tab active class="border-0">
                  <template v-slot:title>Fees Payments</template>
                  <div class="card">
                    <div class="card-body">
                      <table
                        class="table table-sm mt-2"
                        style="color: black;"
                        density="compact"
                      >
                        <thead>
                          <tr>
                            <th>Term</th>
                            <th>Year</th>
                            <th>Receipt No</th>
                            <th>Amount</th>
                            <th>Date</th>
                            <th>Re-Print</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in feespayments" :key="item.id">
                            <td>{{ item.term_name }}</td>
                            <td>{{ item.year }}</td>
                            <td>{{ item.receipt_id }}</td>
                            <td>{{ commas(item.total) }}</td>
                            <td>{{ item.pay_date }}</td>
                            <td>
                              <router-link
                                :to="{
                                  path: '/printreciept',
                                  query: { id: item.receipt_id },
                                }"
                                type="button"
                                class="btn-sm btn btn-primary"
                              >
                                <i class="mdi mdi-printer"></i>
                              </router-link>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-tab>
                <b-tab class="border-0">
                  <template v-slot:title>Other Payments</template>
                  <div class="card">
                    <div class="card-body">
                      <table
                        class="table table-sm mt-2"
                        style="color: black;"
                        density="compact"
                      >
                        <thead>
                          <tr>
                            <th>Term</th>
                            <th>Fees</th>
                            <th>Amount</th>
                            <th>Paid</th>
                            <th>Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in otherpayments" :key="item.id">
                            <td>{{ item.schoolterm.name }} {{ item.year }}</td>
                            <td>{{ item.fees.name }}</td>
                            <td>{{ commas(item.fees.amount) }}</td>
                            <td>{{ commas(item.amountpaid) }}</td>
                            <td>{{ item.created_at }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-tab>
                <b-tab class="border-0">
                  <template v-slot:title>Academic Reports</template>
                  <div class="card">
                    <div class="card-body">
                      <table
                        class="table table-sm mt-2"
                        style="color: black;"
                        density="compact"
                      >
                        <thead>
                          <tr>
                            <th>Year</th>
                            <th>Class</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in otherpayments" :key="item.id">
                            <td>{{ item.year }}</td>
                            <td>{{ item.fees.name }}</td>
                            <td>
                              <router-link
                                :to="{
                                  path: '/printreciept',
                                  query: { id: item.receipt_id },
                                }"
                                type="button"
                                class="btn-sm btn btn-success"
                              >
                                <i class="mdi mdi-printer"></i>
                              </router-link>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="edit-student"
        centered
        title="Edit Student Data"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="editStudent">
          <div class="row mb-2">
            <div class="col-md-2 m-0">
              <img
                :src="getFiles(student_photo)"
                height="60"
                class="rounded-3"
              />
            </div>
            <div class="col-md-10 m-0">
              <label>Student Photo</label>
              <input
                v-on:change="onPhotoChange"
                type="file"
                class="form-control"
              />
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-6 m-0">
              <label>First Name</label>
              <input v-model="first_name" type="text" class="form-control" />
            </div>
            <div class="col-md-6 m-0">
              <label>Last Name</label>
              <input v-model="last_name" type="text" class="form-control" />
            </div>
          </div>
          <label>Gender</label>
          <select class="form-control" v-model="gender"
            ><option>Female</option
            ><option>Male</option></select
          >
          <label>Date of Birth</label>
          <input v-model="dob" type="date" class="form-control" />
          <label>District</label>
          <input v-model="district" type="text" class="form-control" />
          <label>Address</label>
          <input v-model="address" type="text" class="form-control" />
          <label>SchoolPay Codee</label>
          <input v-model="school_pay_code" type="text" class="form-control" />
          <div class="mt-2 d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('edit-student')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> YES</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Student Profile",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Student Profile",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Students", active: true },
      ],
      userData: JSON.parse(localStorage.getItem("user")),
      students: [],
      feespayments: [],
      otherpayments: [],
      first_name: "",
      last_name: "",
      gender: "",
      dob: "",
      district: "",
      address: "",
      school_pay_code: "",
      studentphoto: "",
      student_photo: "",
      amount: 0,
      total: 0,
      paid: 0,
      bursarvalue: "",
      bursarytype: "",
      exemptions: 0,
      balances: 0,
    };
  },
  created() {
    this.showmember();
    this.showfeepayments();
  },
  methods: {
    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getAge(dateString) {
      let birth = new Date(dateString);
      let now = new Date();
      let beforeBirth =
        (() => {
          birth.setDate(now.getDate());
          birth.setMonth(now.getMonth());
          return birth.getTime();
        })() < birth.getTime()
          ? 0
          : 1;
      return now.getFullYear() - birth.getFullYear() - beforeBirth + 1;
    },
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "students/" + name;
      return imagelink;
    },
    async showmember() {
      this.student_id = this.$route.query.id;
      let url = `/studentprofile/${this.student_id}`;
      await axios.get(url).then((response) => {
        this.students = response.data.students;
      });
    },
    async showfeepayments() {
      this.student_id = this.$route.query.id;
      let url = `/profilefeespayments/${this.student_id}`;
      await axios.get(url).then((response) => {
        this.feespayments = response.data.payments[0].payment;
        this.amount = response.data.payments[0].paid;
        this.total = response.data.payments[0].total;
        this.paid = response.data.payments[0].payment.total;
        this.bursarytype = response.data.payments[0].bursary.bursarytype;
        this.bursaryvalue = response.data.payments[0].bursary.bursaryvalue;
        this.exemptions = response.data.payments[0].exemptions;
        this.balances = response.data.payments[0].balances;
      });
    },
    onPhotoChange(e) {
      this.studentphoto = e.target.files[0];
    },
    edit(studentphoto, fname, lname, gender, dob, district, address, code) {
      this.student_photo = studentphoto;
      this.first_name = fname;
      this.last_name = lname;
      this.gender = gender;
      this.dob = dob;
      this.district = district;
      this.address = address;
      this.school_pay_code = code;
      this.$bvModal.show("edit-student");
    },
    async editStudent() {
      const config = { headers: { "content-type": "multipart/form-data" } };
      this.student_id = this.$route.query.id;
      let formData = new FormData();
      formData.append("student_photo", this.studentphoto);
      formData.append("student", this.student_id);
      formData.append("first_name", this.first_name);
      formData.append("last_name", this.last_name);
      formData.append("gender", this.gender);
      formData.append("dob", this.dob);
      formData.append("district", this.district);
      formData.append("address", this.address);
      formData.append("school_pay_code", this.school_pay_code);
      let url = "/editstudent";
      await axios.post(url, formData, config).then((response) => {
        if (response.status == 200) {
          this.$router.go();
        }
      });
    },

    async showOtherPayments() {
      this.student_id = this.$route.query.id;
      let url = `/profileotherpayments/${this.student_id}`;
      await axios.get(url).then((response) => {
        this.otherpayments = response.data.otherpayments;
      });
    },
  },
};
</script>
